import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * File Download Service
 */
@Injectable({ providedIn: 'root' })
export class FileDownloadService {
  private readonly _serviceName = 'FileDownloadService';

  constructor(private http: HttpClient) {}

  /**
   * Downloads the current log file (Blob) from the server
   */
  downloadFile(url: string) {
    console.log(`${this._serviceName}.downloadFiles(url:string) url=${url}`);

    const options = { responseType: 'blob' as 'json' };

    return this.http.get(url, options);
  }

  /**
   * Creates a download file for string content
   */
  public downloadCsv(csvContent: string, fileName: string) {
    console.log(`${this._serviceName}.downloadImageFileCsv`);

    this.downloadText(csvContent, fileName, 'text/csv');
  }

  /**
   * Creates a download file for JSON content
   */
  public downloadJson(json: string, fileName: string) {
    console.log(`${this._serviceName}.downloadJson`);

    this.downloadText(json, fileName, 'application/json');
  }

  /**
   * Creates a client-side anchor element, then clicks it to initiate the download.
   */
  private downloadText(content: string, fileName: string, contentType: string) {
    console.log(`${this._serviceName}.downloadText`);

    const a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([content], { type: contentType }));
    a.download = fileName;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public downloadBase64Content(content: string, fileName: string, contentType: string) {
    console.log(`${this._serviceName}.downloadText`);

    const arr = this.base64ToArrayBuffer(content);

    const a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([arr], { type: contentType }));
    a.download = fileName;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  /**
   * Converts a base64 string to an array buffer.
   */
  private base64ToArrayBuffer(base64: string) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
}